module.exports = __webpack_public_path__ + "img/img (36).61cebde2.png";